module.exports = __webpack_public_path__ + "img/wellness_assessment_primary.4a97b3e3.svg";